// removed by extract-text-webpack-plugin
module.exports = {"echart-box":"Chart__echart-box__117K2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/chart/Chart.styl
// module id = 263
// module chunks = 0